import { render, staticRenderFns } from "./InstructionalStatusTable.vue?vue&type=template&id=5dae0c16&scoped=true"
import script from "./InstructionalStatusTable.vue?vue&type=script&lang=js"
export * from "./InstructionalStatusTable.vue?vue&type=script&lang=js"
import style0 from "./InstructionalStatusTable.vue?vue&type=style&index=0&id=5dae0c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae0c16",
  null
  
)

export default component.exports